
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { Filter } from "@/cms-services/filter";
import draggable from "vuedraggable";
import stringEditor from "@/components/common/inline-editor/string.vue";

@Component({
  components: {
    draggable,
    stringEditor,
  },
})
export default class QuizOptions extends Vue {
  @Prop({ required: true }) quizQuestionId!: number;
  @Prop({ default: 1 }) questionType!: number;

  loading = false;
  adding = false;
  $message: any;

  optionDataSource: ListDataSource = new ListDataSource({
    className: "quizOption",
    config: {
      pageIndex: 1,
      pageSize: 100,
      orderFieldName: "Priority",
      orderFieldDirection: "ASC",
    },
  });

  get options() {
    return this.optionDataSource.items || [];
  }
  
  expandedExplanationId: number | null = null;
  
  toggleExplanation(optionId: number) {
    this.expandedExplanationId = this.expandedExplanationId === optionId ? null : optionId;
  }

  @Watch("quizQuestionId", { immediate: true })
  onQuizQuestionIdChange() {
    this.loadOptions();
  }

  async loadOptions() {
    if (!this.quizQuestionId) return;
    
    this.loading = true;
    try {
      this.optionDataSource.config.filter = JSON.stringify([
        new Filter("quizQuestionId", this.quizQuestionId),
      ]);
      await this.optionDataSource.get();
    } catch (e) {
      console.error("Ошибка загрузки вариантов:", e);
    } finally {
      this.loading = false;
    }
  }

  getOptionDataSource(option: any) {
    return new ObjectDataSource({
      id: option.id,
      model: option,
      className: "quizOption",
      config: {},
    });
  }

  getOptionLetter(index: number): string {
    return String.fromCharCode(65 + index); // A, B, C, D...
  }

  async addOption() {
    this.adding = true;
    try {
      const newOption = {
        caption: `Вариант ${this.getOptionLetter(this.options.length)}`,
        quizQuestionId: this.quizQuestionId,
        isCorrect: false,
        instanceStateId: 4,
        priority: this.options.length + 1,
      };
      await this.optionDataSource.add(newOption, true);
      this.$message?.("Вариант добавлен");
    } catch (e) {
      console.error("Ошибка создания варианта:", e);
      this.$message?.("Ошибка создания варианта");
    } finally {
      this.adding = false;
    }
  }

  async removeOption(option: any) {
    if (!confirm("Удалить вариант?")) return;
    
    try {
      await this.optionDataSource.remove(option.id);
      this.$message?.("Вариант удален");
    } catch (e) {
      console.error("Ошибка удаления варианта:", e);
    }
  }

  async updateIsCorrect(option: any) {
    try {
      await this.getOptionDataSource(option).updateField({
        fieldName: "isCorrect",
        fieldValue: option.isCorrect,
      });
    } catch (e) {
      console.error("Ошибка обновления:", e);
    }
  }

  async onDragEnd() {
    const updatePromises = this.options.map((opt: any, index: number) => {
      return this.getOptionDataSource(opt).updateField({
        fieldName: "priority",
        fieldValue: index + 1,
      });
    });

    try {
      await Promise.all(updatePromises);
    } catch (e) {
      console.error("Ошибка обновления приоритетов:", e);
    }
  }
}
